import { connect } from 'react-redux'
import ActionRemoveWork from './action-remove-work'
import { getContribution } from '../../../../../stores/discussion/discussion.selectors'
import { distanceInWords } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const action = getContribution(state, id)
  return {
    id,
    name: action.originator.full_name,
    timestamp:
      action.created_at &&
      distanceInWords(new Date(), new Date(action.created_at))
  }
}

export default connect(
  mapStateToProps,
  null
)(ActionRemoveWork)
